import { API } from './api'


export async function GET_NOTIFICATIONS() {
	const { data } = await API.get(`notifications`);

	return data;
}

export async function MARK_READ(identifier) {
	const { data } = await API.put(`notification/read/${identifier}`);

	return data;
}

export async function DOWNLOAD_NOTIFICATION(notificationID) {
	const { data } = await API.get(`notification/download/${notificationID}`);

	return data.link;
}
